import { ApiRequest, PagedList } from 'framework/api';
import { GridDataItem } from 'controls/grid/gridDataItem';
import { MetricInfo } from 'framework/entities/metricInfo';
import { MetricValue } from 'framework/entities/metricValue';
import { MetricConfiguration } from 'areas/metrics/components/MetricSelector/types';
import { getUnitOrConversion } from 'areas/metrics/components/MetricSelector/utils/getUnitOrConversion';
import { DataRegistryEntry } from 'areas/management/data-registry/dataRegistryEntry';

export type SearchMetricsArgs = {
	accountId?: string;
	ids: string[];
	includeSubaccounts?: boolean;
};

export function searchMetrics(args: SearchMetricsArgs) {
	return new ApiRequest<PagedList<GridDataItem<DataRegistryEntry>>>({
		url: `metrics/registeredMetrics/search`,
		accountBased: true,
		accountId: args.accountId,
		subaccountsFilter: true,
		includeSubaccounts: args.includeSubaccounts,
		payload: {
			skip: 0,
			take: 1000,
			filter: {
				logic: 'and',
				filters: [
					{
						logic: 'or',
						filters: args.ids.map((id) => ({
							operator: 'eq',
							value: id,
							field: 'metricId',
						})),
					},
				],
			},
		},
	});
}

export type MetricPayload = {
	metricId: string;
	conversion?: string;
	customUnit?: string;
	conversionUnit?: string;
};

export function buildMetricPayload(config: MetricConfiguration): MetricPayload {
	return {
		metricId: config.metricId,
		...getUnitOrConversion(config),
	};
}

export function buildMetricPayloads(configs: MetricConfiguration[]): MetricPayload[] {
	return configs.map(buildMetricPayload);
}

export function getMetricLatestValue(configs: MetricConfiguration[], count: number = 1) {
	return new ApiRequest<MetricInfo[]>({
		url: `metrics/registeredMetrics/lastinfo?last=${count}`,
		method: 'POST',
		payload: buildMetricPayloads(configs),
	});
}
